import { BrowserCacheLocation, Configuration, LogLevel } from '@azure/msal-browser';

const isIE = window.navigator.userAgent.indexOf("MSIE ") > -1 || window.navigator.userAgent.indexOf("Trident/") > -1;

export const msalConfig: Configuration = {
  auth: {
    clientId: 'a7c1b5d1-b5ff-42ab-baab-81851c1e2250',
    authority: 'https://login.microsoftonline.com/2e68ef5f-d9aa-48c7-b148-ccb84302a6ee',
    redirectUri: 'http://localhost:4200/login-entra-callback',
    postLogoutRedirectUri: 'http://localhost:4200',
    navigateToLoginRequestUrl: false
  },
  cache: {
    cacheLocation: BrowserCacheLocation.LocalStorage,
    storeAuthStateInCookie: isIE,
  },
  system: {
    loggerOptions: {
      loggerCallback: (logLevel, message, containsPii) => {
        console.log(message);
      },
      logLevel: LogLevel.Verbose,
      piiLoggingEnabled: true
    }
  }
};

export const loginRequest = {
  scopes: ['openid', 'profile', 'email'] // minimal scopes
};
